export function insertElementsOnPosition({ parentArray, insertableValues, position }) {
  return [
    ...parentArray.slice(0, parentArray.length - position),
    ...(Array.isArray(insertableValues) ? [...insertableValues] : [insertableValues]),
    ...parentArray.slice(parentArray.length - position),
  ]
}
